import React from "react";

import { Button, Stack, Typography } from "@mui/material";

interface IProps {
  title: string;
  onShowAll: () => void;
  /** EC-3: Show All stays disabled until the section reaches a populated state. */
  showAllDisabled?: boolean;
  /** Hide Show All entirely — e.g. an empty section has no full view to open. */
  hideShowAll?: boolean;
  children: React.ReactNode;
}

export const InsightsSectionCard: React.FC<IProps> = ({
  title,
  onShowAll,
  showAllDisabled,
  hideShowAll,
  children
}) => {
  return (
    <Stack
      sx={{
        gap: "16px",
        p: "16px",
        borderRadius: "8px",
        boxShadow: "0px 1px 2px rgba(18, 18, 23, 0.1)",
        bgcolor: "#fff"
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "24px", color: "#071F35" }}>
          {title}
        </Typography>
        {!hideShowAll && (
          <Button
            variant="text"
            onClick={onShowAll}
            disabled={showAllDisabled}
            sx={{ textTransform: "none", fontWeight: 500, color: "#26A6AE" }}
          >
            Show All
          </Button>
        )}
      </Stack>
      {children}
    </Stack>
  );
};
